// extracted by mini-css-extract-plugin
module.exports = {"About":"AboutNulango_About__2khAJ","contactUs":"AboutNulango_contactUs__LuctV","header_text":"AboutNulango_header_text__3sMwe","aboutText":"AboutNulango_aboutText__39fSp"};